import React, { Children, ReactElement, cloneElement, isValidElement, type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupListRow, ListRowProps } from "./components/ListRow";
export interface ListTableProps {
  className?: string;
  header?: JSX.Element;
  footer?: JSX.Element;
  rowClassName?: string;
  children: ReactElement<ListRowProps, typeof SupListRow> | ReactElement<ListRowProps, typeof SupListRow>[];
}

export function SupListTable({ children, className, rowClassName, header, footer }: ListTableProps) {
  return (
    <div className={twMerge("sup-list-table border-0.5 border-neutral-600 bg-neutral-25", className)}>
      {header}
      <div className="sup-list-table-rows px-4 text-neutral-600">
        {Children.map(children, row => {
          if (!isValidElement(row)) {
            return null;
          }

          return cloneElement(row, { className: rowClassName ?? row.props.className });
        })}
      </div>
      {footer}
    </div>
  );
}
